import React from 'react'

import { LntTag } from '@app/components/base'

import type { MouseEvent } from 'react'
import type { LntTagRenderProps } from './types'

export const LntTagRender: React.FC<LntTagRenderProps> = ({
  className: outerClassName,
  value,
  label,
  disabled,
  onClose,
  onTagClose,
  type
}) => {
  const onPreventMouseDown = (event: MouseEvent<HTMLSpanElement>): void => {
    event.preventDefault()
    event.stopPropagation()
  }

  const onCloseHandle = (event: MouseEvent<HTMLElement, globalThis.MouseEvent>): void => {
    onClose?.(event)
    onTagClose?.(event, value)
  }

  return (
    <LntTag
      className={ outerClassName }
      type={ type }
      disabled={ disabled }
      onClose={ onCloseHandle }
      onMouseDown={ onPreventMouseDown }
    >
      { label }
    </LntTag>
  )
}
